<template>
    <div class="home">
        <div class="under">
            <img class="construction" src="@/assets/img/404.png" />
            <span>sorry～ </span>
            <span>您访问的页面找不到了，请稍后再试。</span>
            <van-button class="btn" round @click="router.go(-1)">刷 新</van-button>
        </div>
    </div>
</template>

<script lang="ts">
import { useRouter } from 'vue-router';
export default {
    setup() {
        const router = useRouter();
        return { router };
    },
};
</script>

<style lang="less" scoped>
.home {
    height: 100%;
    background: #ffffff;
}
.under {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    .construction {
        width: 160px;
        height: 160px;
        margin-bottom: 16px;
    }
    span {
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #999;
        line-height: 20px;
        margin-top: 10px;
    }
    .btn {
        margin-top: 28px;
        width: 160px;
        height: 40px;
        background: #ffffff;
        border-radius: 40px;
        border: 2px solid #dcdee0;
        color: #323233;
        font-size: 17px;
    }
}
</style>
